import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, Search, Mail, ArrowLeft, AlertTriangle } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen flex items-center justify-center bg-bg-dark font-sans px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Visual - Using your bg-blue for the circle */}
        <div className="mb-10 relative inline-block">
          <div className="w-40 h-40 rounded-full bg-bg-blue border border-white/10 flex items-center justify-center shadow-2xl">
            <span className="text-7xl font-bold tracking-tighter text-white">
              404
            </span>
          </div>
          <div className="absolute -top-1 -right-1 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center border-4 border-bg-dark">
            <AlertTriangle className="w-6 h-6 text-white" />
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-Poppins">
          Lost in Navigation
        </h1>
        <p className="text-lg text-gray-400 mb-10 max-w-md mx-auto font-english">
          The page you're looking for doesn't exist or has been moved to a new destination.
        </p>

        {/* Navigation Options - Using your bg-medium and light variants */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          <Link
            to="/"
            className="group bg-bg-medium p-6 rounded-xl border border-white/5 hover:border-orange-500/50 transition-all duration-300"
          >
            <Home className="w-8 h-8 mx-auto mb-3 text-orange-500 group-hover:scale-110 transition-transform" />
            <h3 className="font-semibold text-white mb-1">Home</h3>
            <p className="text-xs text-gray-500">Return to start</p>
          </Link>

          <Link
            to="/search"
            className="group bg-bg-medium p-6 rounded-xl border border-white/5 hover:border-orange-500/50 transition-all duration-300"
          >
            <Search className="w-8 h-8 mx-auto mb-3 text-orange-500 group-hover:scale-110 transition-transform" />
            <h3 className="font-semibold text-white mb-1">Browse</h3>
            <p className="text-xs text-gray-500">Search vehicles</p>
          </Link>

          <Link
            to="/contact"
            className="group bg-bg-medium p-6 rounded-xl border border-white/5 hover:border-orange-500/50 transition-all duration-300"
          >
            <Mail className="w-8 h-8 mx-auto mb-3 text-orange-500 group-hover:scale-110 transition-transform" />
            <h3 className="font-semibold text-white mb-1">Support</h3>
            <p className="text-xs text-gray-500">Get assistance</p>
          </Link>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 rounded-lg border border-white/20 text-white hover:bg-white hover:text-bg-dark transition-all font-medium font-DmSans"
          >
            <ArrowLeft className="w-4 h-4" /> Go Back
          </button>
          <Link
            to="/"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-bold transition-all shadow-lg shadow-orange-500/20 font-DmSans"
          >
            Back to Home
          </Link>
        </div>

        {/* Help Link */}
        <div className="mt-12">
          <p className="text-gray-500 text-sm font-english">
            Still can't find it?{" "}
            <Link to="/contact" className="text-orange-500 hover:underline">
              Contact our support team
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default NotFound;